import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  refreshTime: "间隔刷新时间",
  updateTimer: "数据源轮询时间",
  restDataUrl: "外接数据源地址"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
